import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useMemo, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import debounce from 'lodash/debounce';
import noop from 'lodash/noop';
import { useIntl } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import TextArea from '@atlaskit/textarea';
import { messages } from './messages';
export var EditOtherOption = function EditOtherOption(_ref) {
  var dropdown = _ref.dropdown,
    isDisabled = _ref.isDisabled,
    value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id;
  var intl = useIntl();

  // Local state required to show textarea changes as onChange callback is debounced.
  // Without it, user will only see their last inputted character added within the debounce period.
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    textAreaValue = _useState2[0],
    setTextAreaValue = _useState2[1];
  useEffect(function () {
    if (fg('debounce_proforma_text_field_edits')) {
      setTextAreaValue(value);
    }
  }, [value]);
  var debouncedOnChange = useMemo(function () {
    return fg('debounce_proforma_text_field_edits') ? onChange ? debounce(onChange, 500) : noop : noop;
  }, [onChange]);
  var handleTextAreaChange = useCallback(function (e) {
    e.persist();
    setTextAreaValue(e.target.value);
    debouncedOnChange(e);
  }, [debouncedOnChange]);
  var TextWrapper = dropdown ? OptionalTextWrapperDropdown : OptionalTextWrapper;
  return /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(TextArea, {
    appearance: "standard",
    isCompact: false,
    placeholder: intl.formatMessage(messages.choiceDropdownNewOption),
    isDisabled: isDisabled,
    isReadOnly: false,
    minimumRows: 2,
    maxHeight: "none",
    isMonospaced: false,
    value: fg('debounce_proforma_text_field_edits') ? textAreaValue : value,
    resize: "smart",
    spellCheck: false,
    onBlur: undefined,
    onChange: fg('debounce_proforma_text_field_edits') ? handleTextAreaChange : function (event) {
      onChange ? onChange(event) : undefined;
    },
    onFocus: undefined,
    id: id + '-other-option'
  }));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var OptionalTextWrapper = styled.div({
  marginLeft: "var(--ds-space-300, 24px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var OptionalTextWrapperDropdown = styled.div({
  marginTop: "var(--ds-space-050, 4px)"
});